<template>
  <el-dialog
    custom-class="pay"
    :title="type === 0 ? '微信支付' : '支付宝支付'"
    :append-to-body="true"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="pay_wrap">
      <div class="pay_content">
        <div class="pay_url" id="qrcode" ref="qrcode"></div>
        <div class="pay_tip">
          <p class="pay_text">
            请使用{{ type === 0 ? "微信" : "支付宝" }}扫一扫
          </p>
          <p class="pay_text">扫描二维码支付</p>
        </div>
      </div>

      <Button class="pay_btn" @click="$emit('close')">
        选择其它支付方式
      </Button>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "PayDialog",
  props: {
    type: {
      // 0 - 微信支付 1 - 支付宝支付
      type: Number,
      default: 0,
    },
    payUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      code: null,
    };
  },
  watch: {
    payUrl(url) {
      // 监听支付地址，生成二维码
      this.$nextTick(() => {
        url && this.createCode(url);
      });
    },
  },
  methods: {
    createCode(url) {
      if (this.code) {
        this.$refs.qrcode.innerHTML = "";
        this.code.clear();
      }

      this.code = new QRCode(this.$refs.qrcode, {
        width: 160,
        height: 160,
        text: url,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.pay {
  .pay_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    .pay_content {
      @include flex();
      margin-bottom: rem(60);
    }

    .pay_url {
      margin-right: 30px;
    }

    .pay_tip {
      min-width: rem(160);
      padding: 8px 20px;
      background: $theme-color;
      border-radius: 5px;
      margin-bottom: rem(30);

      .pay_text {
        font-size: rem(14);
        color: $white;
        line-height: 20px;
        text-align: center;
      }
    }

    .pay_btn {
      width: rem(160);
      padding: rem(20);
      margin: 0;
      border-radius: 5px;
    }
  }
}
</style>
